import type { ThemeId } from '@whistler-ui/k2/constants/global';
import { THEME_IDS } from '@whistler-ui/k2/constants/global';
import { getTheme } from '@whistler-ui/k2/styles/themes';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { SETTINGS } from '../constants';
import { isThemeId, resolveBrandConfig } from './theme/brands';
import type { Config } from './theme/brands/types/brands';

export type ThemeColors = Record<string, string>;

export interface ThemeState {
  themeId: ThemeId;
  config: Config;
  colors: ThemeColors;
}

export type ThemeStore = ThemeState & {
  setTheme: (themeId: ThemeId) => void;
  resetStore: () => void;
};

const resolvedThemeId: ThemeId = isThemeId(SETTINGS.THEME_ID)
  ? SETTINGS.THEME_ID
  : THEME_IDS.NETLYNC;

export const initialState: ThemeState = {
  themeId: resolvedThemeId,
  config: resolveBrandConfig(resolvedThemeId),
  colors: getTheme(resolvedThemeId).styles,
};

export const useThemeStore = create<ThemeStore>()(
  devtools(
    set => ({
      ...initialState,
      setTheme: themeId => {
        if (!isThemeId(themeId)) {
          return;
        }

        set(
          () => ({
            themeId,
            config: resolveBrandConfig(themeId),
            colors: getTheme(themeId).styles,
          }),
          false,
          'themeStore/setTheme',
        );
      },
      resetStore: () => {
        set(() => initialState, false, 'themeStore/resetStore');
      },
    }),
    { name: 'themeStore', enabled: SETTINGS.IS_DEV },
  ),
);
